import { useRef, useEffect, useState } from "react";
import type { FC } from "react";
import { accordionStyles } from "./Accordion.styles";
import type { AccordionItemProps } from "./Accordion.types";

export const AccordionItem: FC<AccordionItemProps> = ({
  question,
  answer,
  isOpen,
  onToggle,
}) => {
  const contentRef = useRef<HTMLDivElement>(null);
  const [maxHeight, setMaxHeight] = useState("0px");

  useEffect(() => {
    if (isOpen && contentRef.current) {
      setMaxHeight(`${contentRef.current.scrollHeight}px`);
    } else {
      setMaxHeight("0px");
    }
  }, [isOpen]);

  return (
    <div className={`${accordionStyles.item}`} >
      <h2
        className={accordionStyles.header(isOpen)}
        onClick={onToggle}
        aria-expanded={isOpen}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => e.key === "Enter" && onToggle()}
      >
        <button
          type="button"
          className={accordionStyles.buttonIcon}
          aria-label="Toggle Accordion"
          onClick={(e) => {
            e.stopPropagation();
            onToggle();
          }}
        >
          <span className={`accordion-arrow-icon-wrapper ${isOpen ? "rotate" : ""}`}>
            <span className="accordion-arrow-icon" />
          </span>
        </button>
        {question}
      </h2>

      <div
        ref={contentRef}
        className="overflow-hidden transition-all duration-500 ease-in-out"
        style={{ maxHeight }}
      >
        <div className={accordionStyles.panel}>{answer}</div>
      </div>
    </div>
  );
};
